/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ProjectSelectionMode {
  DISABLED = 'disabled',
  POST_BOOKING = 'post_booking',
  IN_BOOKING_OPTIONAL = 'in_booking_optional',
  IN_BOOKING_REQUIRED = 'in_booking_required',
}
